import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
// import {AppComponent} from '../../../app.component';
import {AdminLayoutComponent} from '../../../layouts/admin-layout/admin-layout.component';
import {Router} from '@angular/router';

import {environment} from '../../../../environments/environment';
import {AuthService} from '../../../services/auth/auth.service';
import {CatalogosService} from '../../../services/catalogos.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit {
  /**
   * Acá se declaran las variables a utilizar en el resto de las funciones del componente, importante énfasis en las siguientes:
   *
   * code: Código del mensaje de respuesta a mostrar en la función.
   * titulo: Título a enviar; solo si se recibe con la respuesta del endpoint.
   * detalle: Detalle a enviar; solo si se recibe con la respuesta del endpoint.
   */
    usuario: any;
    nombreCompletoUsuario = '';
    loggedIn = false;
    visibleSpinner = false;

    nombreSistema: string = environment.nombreSistema;

    // Variables para mensaje
    code: any;
    titulo: any;
    detalle: any;
    sw: any;

    // Tramites pendientes
    load: boolean;
    tmsg: boolean;
    tp = false;
    tview = false;
    tpLength: string;

    // popups
    img: string;
    url: string;
    visible: boolean = false;
    header: string = '';
    message: string = '';

    constructor(public app: AdminLayoutComponent,
                private router: Router,
                private authService: AuthService,
                private catalogosService: CatalogosService) {}

    ngOnInit(): void {
        this.loggedIn = this.authService.getIsLoggedIn();
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        if (this.loggedIn) {
            this.obtenerInformacionUsuario();

            if (localStorage.getItem('fis') === undefined || localStorage.getItem('fis') === null) {
                localStorage.setItem('fis', Date.now().toString());
                this.sw = 'Start';
                this.obtenerTramitesPendientes();
            }
            const tp = localStorage.getItem('tp') ? localStorage.getItem('tp').toString() : '0';
            if (tp !== '0') {
              this.tpLength = tp;
              this.tview = true;
              this.tmsg = false;
              setTimeout(() => {
                this.tp = true;
                this.load = true;
              }, 500);
            }
        } else {
            this.router.navigate(['auth/login']);
        }
    }

    obtenerTramitesPendientes(): void {
      this.tp = true;
      this.load = true;
      this.tmsg = true;
    }

    tramite(tramite): void {
      if (tramite.length !== 0) {
        this.tpLength = tramite.length;
        this.tview = true;
      } else {
        this.tview = false;
      }
    }

    obtenerInformacionUsuario(): void {
        if (localStorage.getItem('un') === null || localStorage.getItem('un') === undefined) {
            this.router.navigate(['auth/login']);
        } else {
            this.usuario = localStorage.getItem('un');
            this.nombreCompletoUsuario = localStorage.getItem('nc');
        }
    }

  cerrarSesion(): void {
    // para popups se muestren en un rago de fechas determinado
    let now = new Date();

    if (now >= new Date('2024-04-24T00:00:00') && now <= new Date('2024-05-03T23:59:59')) {
      setTimeout(() => {
        this.popUp();
      }, 500);
    } else {
      this.router.navigate(['auth/logout']);
    }
  }

  popUp() {
    this.header = 'Encuesta de satisfacción';
    this.img = 'assets/img/anuncios/encuesta25042024.png';
    this.url = 'https://forms.office.com/r/yVAtvU1MWu';
    this.message = 'Estimado usuario, le invitamos a participar en nuestra encuesta de satisfacción. Agradecemos su colaboración.';
    this.visible = true;
  }

  accept() {
    this.visible = false;
    this.router.navigate(['auth/logout']);
  }
}
